declare const grecaptcha: {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

declare const SETTINGS_search: {
  recaptchaSiteKey: string;
  recaptchaVerifyUrl: string;
  [key: string]: any;
};

export async function validateRecaptcha(action: string): Promise<boolean> {
  try {
    // 1. בקש token מ-Google
    const token = await new Promise<string>((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(SETTINGS_search.recaptchaSiteKey, { action })
          .then(resolve)
          .catch(reject);
      });
    });

    // 2. שלח token לשרת לאימות
    const response = await fetch(SETTINGS_search.recaptchaVerifyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      console.error('reCAPTCHA verify API returned:', response.status);
      return true; // fallback — לא חוסמים אם השרת לא זמין
    }

    const data = await response.json();
    return data.ok === true;
  } catch (error) {
    console.error('reCAPTCHA validation error:', error);
    return true; // fallback — לא חוסמים אם יש שגיאת רשת
  }
}
